export default "__VITE_ASSET__9d03e466__"